import { Col, Container, Row, Spinner } from "react-bootstrap";
import React from "react";
import { useRouter } from "next/navigation";
import { useAuthContext } from "@/context/AuthContext";
import { currentUser } from "@/firebase/firebaseAuth";
import { authUserForEmailVerification, requiresEmailVerification } from "@/lib/EmailVerificationGate";
import { bootstrapAuthUser } from "@/lib/authBootstrapCoordinator";
import { routeAfterAuthBootstrap } from "@/lib/entrySessionRoute";
import { resolveSessionRoute } from "@/lib/SessionResolver";
import { applySessionRouteDecision } from "@/lib/applySessionRoute";
import { peekSessionRouteLoopCount } from "@/lib/SessionRouteLoop";
import { appendAffiliateRefToPath, getAffiliateRefCodeFromRuntime } from "@/lib/AffiliateLink";
export default function Home() {
  const {
    user,
    loading,
    authDegraded
  } = useAuthContext();
  const router = useRouter();
  React.useEffect(() => {
    let isMounted = true;
    const run = async () => {
      const firebaseUser = currentUser();
      const pre = resolveSessionRoute({
        authLoading: loading,
        authDegraded,
        contextUser: user,
        firebaseUser,
        requiresEmailVerification: requiresEmailVerification(authUserForEmailVerification(user, firebaseUser)),
        currentPath: "/",
        loopCount: peekSessionRouteLoopCount(),
        mode: "entry"
      });
      if (pre.kind === "wait") {
        return;
      }
      if (pre.kind === "navigate" && (pre.reason === "signed_out" || pre.reason === "email_unverified")) {
        const affiliateRef = getAffiliateRefCodeFromRuntime();
        const decision = pre.route === "/login" && affiliateRef ? {
          ...pre,
          route: appendAffiliateRefToPath(pre.route, affiliateRef)
        } : pre;
        await applySessionRouteDecision({
          decision,
          uid: user?.uid || firebaseUser?.uid,
          router,
          source: "index_root"
        });
        return;
      }
      // Recover / unexpected signed-out states must not sit on the
      // splash spinner forever (the Aug 18 session router treated `/`
      // as an auth form that could "render" while signed out).
      if (!user?.uid) {
        router.replace(appendAffiliateRefToPath("/login", getAffiliateRefCodeFromRuntime()));
        return;
      }
      const {
        ensure,
        profile
      } = await bootstrapAuthUser({
        uid: user.uid,
        providerType: user.providerData?.[0]?.providerId || "unknown",
        source: "index_root",
        loadProfile: true
      });
      if (!isMounted) return;
      await routeAfterAuthBootstrap({
        uid: user.uid,
        ensure,
        profile,
        router,
        source: "index_root",
        currentPath: "/"
      });
    };
    void run();
    return () => {
      isMounted = false;
    };
  }, [user, user?.emailVerified, loading, authDegraded, router]);
  return <>
            <Container className="rounded mx-auto d-block" data-sentry-element="Container" data-sentry-source-file="index.tsx">
                <Row className=" align-items-center justify-content-center no-gutters min-dvh-100" data-sentry-element="Row" data-sentry-source-file="index.tsx">
                    <Col className={"d-flex align-items-center justify-content-center"} data-sentry-element="Col" data-sentry-source-file="index.tsx">
                        <Spinner animation="border" className={"text-primary"} role="status" data-sentry-element="Spinner" data-sentry-source-file="index.tsx">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </Col>
                </Row>
            </Container>
        </>;
}